module.exports = __webpack_public_path__ + "static/media/store.88e76d0c.mp4";